var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'AutoawardList'
      }
    }
  }, [_vm._v("自動派獎設定")]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'AutoawardList'
      }
    }
  }, [_vm._v("自動派獎列表")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? " 編輯" : "新增") + "自動派獎 ")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row mb-2 align-items-end"
  }, [_c('div', {
    staticClass: "col-8 d-flex items-center"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? "\u7DE8\u8F2F" : "\u65B0\u589E") + "自動派獎 ")])])]), _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('section', {
    staticClass: "row mb-8"
  }, [_c('div', {
    staticClass: "col-12 col-xl-10"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "標題",
      "label-for": "title"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "title",
      "type": "text",
      "state": _vm.v$.form.title.$error ? false : null,
      "readonly": _vm.isView
    },
    model: {
      value: _vm.state.form.title,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "title", $$v);
      },
      expression: "state.form.title"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.title.$error
    }
  }, [_vm._v("此欄位為必填")])], 1), _c('b-form-group', [_c('b-form-row', [_c('b-col', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "活動起日",
      "label-for": "start_at"
    }
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "input-class": {
        'form-control': true,
        'is-invalid': _vm.v$.form.start_at_date.$error
      },
      "language": _vm.zh,
      "format": "yyyy-MM-dd",
      "bootstrap-styling": "",
      "disabled": _vm.isView || _vm.isStarted,
      "disabled-dates": _vm.disabledDates
    },
    model: {
      value: _vm.state.form.start_at_date,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "start_at_date", $$v);
      },
      expression: "state.form.start_at_date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.start_at_date.$error
    }
  }, [_vm._v("活動起日為必填")])], 1)], 1), _c('b-col', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "活動迄日",
      "label-for": "end_at"
    }
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "input-class": {
        'form-control': true,
        'is-invalid': _vm.v$.form.end_at_date.$error
      },
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "bootstrap-styling": "",
      "disabled": _vm.isView,
      "disabled-dates": _vm.disabledEndDates
    },
    model: {
      value: _vm.state.form.end_at_date,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "end_at_date", $$v);
      },
      expression: "state.form.end_at_date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.end_at_date.$error
    }
  }, [_vm._v("活動迄日為必填")])], 1)], 1)], 1)], 1), _c('b-form-group', {
    staticClass: "col-12"
  }, [_c('b-form-radio-group', {
    staticClass: "pt-3",
    attrs: {
      "id": "awardOption"
    },
    model: {
      value: _vm.state.awardOption.type,
      callback: function callback($$v) {
        _vm.$set(_vm.state.awardOption, "type", $$v);
      },
      expression: "state.awardOption.type"
    }
  }, [_c('b-form-radio', {
    staticClass: "form-inline mb-2 col-12",
    attrs: {
      "value": "url",
      "disabled": _vm.isView
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._v(" 顧客下單後立即通知，發漸強導流連結 "), _c('b-form-input', {
    staticClass: "mx-2",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "state": _vm.v$.notificationOption.url.$error || _vm.v$.notificationOption.url.$invalid ? false : null,
      "disabled": _vm.state.awardOption.type != 'url',
      "readonly": _vm.isView
    },
    model: {
      value: _vm.state.notificationOption.url,
      callback: function callback($$v) {
        _vm.$set(_vm.state.notificationOption, "url", $$v);
      },
      expression: "state.notificationOption.url"
    }
  })], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.notificationOption.url.$error || !_vm.v$.notificationOption.url.$invalid
    }
  }, [_vm._v("導流連結為必填，且為網址格式")])], 1), _c('b-form-radio', {
    staticClass: "form-inline mb-2 col-12 flex-wrap",
    attrs: {
      "value": "point",
      "disabled": _vm.isView
    }
  }, [_vm._v(" 顧客取貨後 "), _c('b-form-input', {
    staticClass: "mx-2",
    staticStyle: {
      "width": "5rem"
    },
    attrs: {
      "formatter": _vm.maxLength(5),
      "state": _vm.v$.notificationOption.after_days.$error && _vm.state.awardOption.type == 'point' ? false : null,
      "disabled": _vm.state.awardOption.type != 'point',
      "readonly": _vm.isView
    },
    model: {
      value: _vm.state.notificationOption.after_days,
      callback: function callback($$v) {
        _vm.$set(_vm.state.notificationOption, "after_days", $$v);
      },
      expression: "state.notificationOption.after_days"
    }
  }), _vm._v(" 日發通知，通知後 "), _c('b-form-input', {
    staticClass: "mx-2",
    staticStyle: {
      "width": "5rem"
    },
    attrs: {
      "formatter": _vm.maxLength(5),
      "state": _vm.v$.awardOption.after_days.$error && _vm.state.awardOption.type == 'point' ? false : null,
      "disabled": _vm.state.awardOption.type != 'point',
      "readonly": _vm.isView
    },
    model: {
      value: _vm.plusDay,
      callback: function callback($$v) {
        _vm.plusDay = $$v;
      },
      expression: "plusDay"
    }
  }), _vm._v(" 日發POYA點數 "), _c('b-form-input', {
    staticClass: "mx-2",
    staticStyle: {
      "width": "8rem"
    },
    attrs: {
      "formatter": _vm.maxLength(8),
      "state": _vm.v$.awardOption.point.$error && _vm.state.awardOption.type == 'point' ? false : null,
      "disabled": _vm.state.awardOption.type != 'point',
      "readonly": _vm.isView
    },
    model: {
      value: _vm.state.awardOption.point,
      callback: function callback($$v) {
        _vm.$set(_vm.state.awardOption, "point", $$v);
      },
      expression: "state.awardOption.point"
    }
  }), _vm._v(" 點。 "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }), _vm._v(" （單筆需滿 "), _c('b-form-input', {
    staticClass: "mx-2",
    staticStyle: {
      "width": "8rem"
    },
    attrs: {
      "formatter": _vm.maxLength(8),
      "state": _vm.v$.requirementOption.amount.$error && _vm.state.awardOption.type == 'point' ? false : null,
      "disabled": _vm.state.awardOption.type != 'point',
      "readonly": _vm.isView
    },
    model: {
      value: _vm.state.requirementOption.amount,
      callback: function callback($$v) {
        _vm.$set(_vm.state.requirementOption, "amount", $$v);
      },
      expression: "state.requirementOption.amount"
    }
  }), _vm._v(" 元符合資格，可累贈，活動期間每位會員上限 "), _c('b-form-input', {
    staticClass: "mx-2",
    staticStyle: {
      "width": "8rem"
    },
    attrs: {
      "formatter": _vm.maxLength(8),
      "state": _vm.v$.limitOption.value.$error && _vm.state.awardOption.type == 'point' ? false : null,
      "disabled": _vm.state.awardOption.type != 'point',
      "readonly": _vm.isView
    },
    model: {
      value: _vm.state.limitOption.value,
      callback: function callback($$v) {
        _vm.$set(_vm.state.limitOption, "value", $$v);
      },
      expression: "state.limitOption.value"
    }
  }), _vm._v(" 點） "), _c('b-form-invalid-feedback', {
    attrs: {
      "state": _vm.v$.notificationOption.after_days.$error && _vm.state.awardOption.type == 'point' ? false : null
    }
  }, [_vm._v("取貨後天數為必填，且為數字")]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": _vm.v$.awardOption.after_days.$error && _vm.state.awardOption.type == 'point' ? false : null
    }
  }, [_vm._v("贈禮天數為必填，且為數字")]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": _vm.v$.awardOption.point.$error && _vm.state.awardOption.type == 'point' ? false : null
    }
  }, [_vm._v("點數為必填，且為數字")]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": _vm.v$.requirementOption.amount.$error && _vm.state.awardOption.type == 'point' ? false : null
    }
  }, [_vm._v("單筆累贈必填，且為數字")]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": _vm.v$.limitOption.value.$error && _vm.state.awardOption.type == 'point' ? false : null
    }
  }, [_vm._v("上限必填，且為數字")])], 1), _c('b-form-radio', {
    staticClass: "form-inline mb-2 col-12 flex-wrap",
    attrs: {
      "value": "multiplier",
      "disabled": _vm.isView
    }
  }, [_vm._v(" 顧客取貨後 "), _c('b-form-input', {
    staticClass: "mx-2",
    staticStyle: {
      "width": "5rem"
    },
    attrs: {
      "formatter": _vm.maxLength(5),
      "state": _vm.v$.notificationOption.after_days.$error && _vm.state.awardOption.type == 'multiplier' ? false : null,
      "disabled": _vm.state.awardOption.type != 'multiplier',
      "readonly": _vm.isView
    },
    model: {
      value: _vm.state.notificationOption.after_days,
      callback: function callback($$v) {
        _vm.$set(_vm.state.notificationOption, "after_days", $$v);
      },
      expression: "state.notificationOption.after_days"
    }
  }), _vm._v(" 日發通知，通知後 "), _c('b-form-input', {
    staticClass: "mx-2",
    staticStyle: {
      "width": "5rem"
    },
    attrs: {
      "formatter": _vm.maxLength(5),
      "state": _vm.v$.awardOption.after_days.$error && _vm.state.awardOption.type == 'multiplier' ? false : null,
      "disabled": _vm.state.awardOption.type != 'multiplier',
      "readonly": _vm.isView
    },
    model: {
      value: _vm.plusDay,
      callback: function callback($$v) {
        _vm.plusDay = $$v;
      },
      expression: "plusDay"
    }
  }), _vm._v(" 日發POYA點數 "), _c('b-form-input', {
    staticClass: "mx-2",
    staticStyle: {
      "width": "8rem"
    },
    attrs: {
      "formatter": _vm.maxLength(8),
      "state": _vm.v$.awardOption.multiplier.$error && _vm.state.awardOption.type == 'multiplier' ? false : null,
      "disabled": _vm.state.awardOption.type != 'multiplier',
      "readonly": _vm.isView
    },
    model: {
      value: _vm.state.awardOption.multiplier,
      callback: function callback($$v) {
        _vm.$set(_vm.state.awardOption, "multiplier", $$v);
      },
      expression: "state.awardOption.multiplier"
    }
  }), _vm._v(" 倍。 "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }), _vm._v(" （單筆需滿 "), _c('b-form-input', {
    staticClass: "mx-2",
    staticStyle: {
      "width": "8rem"
    },
    attrs: {
      "formatter": _vm.maxLength(8),
      "state": _vm.v$.requirementOption.amount.$error && _vm.state.awardOption.type == 'multiplier' ? false : null,
      "disabled": _vm.state.awardOption.type != 'multiplier',
      "readonly": _vm.isView
    },
    model: {
      value: _vm.state.requirementOption.amount,
      callback: function callback($$v) {
        _vm.$set(_vm.state.requirementOption, "amount", $$v);
      },
      expression: "state.requirementOption.amount"
    }
  }), _vm._v(" 元符合資格，不可累贈，活動期間每位會員上限 "), _c('b-form-input', {
    staticClass: "mx-2",
    staticStyle: {
      "width": "8rem"
    },
    attrs: {
      "formatter": _vm.maxLength(8),
      "state": _vm.v$.limitOption.value.$error && _vm.state.awardOption.type == 'multiplier' ? false : null,
      "disabled": _vm.state.awardOption.type != 'multiplier',
      "readonly": _vm.isView
    },
    model: {
      value: _vm.state.limitOption.value,
      callback: function callback($$v) {
        _vm.$set(_vm.state.limitOption, "value", $$v);
      },
      expression: "state.limitOption.value"
    }
  }), _vm._v(" 點） "), _c('b-form-invalid-feedback', {
    attrs: {
      "state": _vm.v$.notificationOption.after_days.$error && _vm.state.awardOption.type == 'multiplier' ? false : null
    }
  }, [_vm._v("取貨後天數為必填，且為數字")]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": _vm.v$.awardOption.after_days.$error && _vm.state.awardOption.type == 'multiplier' ? false : null
    }
  }, [_vm._v("贈禮天數為必填，且為數字")]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": _vm.v$.awardOption.multiplier.$error && _vm.state.awardOption.type == 'multiplier' ? false : null
    }
  }, [_vm._v("倍數為必填，且為數字")]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": _vm.v$.requirementOption.amount.$error && _vm.state.awardOption.type == 'multiplier' ? false : null
    }
  }, [_vm._v("單筆累贈必填，且為數字")]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": _vm.v$.limitOption.value.$error && _vm.state.awardOption.type == 'multiplier' ? false : null
    }
  }, [_vm._v("上限必填，且為數字")])], 1)], 1)], 1)], 1)])]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("取消")]), _c('b-overlay', {
    staticClass: "d-inline-block",
    attrs: {
      "show": _vm.isSubmmiting,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [!_vm.isView ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? "確認修改" : "確認新增") + " ")]) : _vm._e()], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }